import {
  BurnQualityCountAggregateByTimeChart,
  BurnQualityCountAggregateByTimeLoader,
} from "firefly-shared-ts-domain";
import React, { FC, useMemo } from "react";
import { Flue } from "firefly-my-chimney-ts-building";
import { useBurnDao } from "firefly-my-chimney-ts-burn";
import { CustomerEnvironmentId } from "firefly-shared-ts-customer-environment";
import { SizeClass } from "shared-ts-ui-responsive";
import { IntervalUtils, useDateTimeNow } from "shared-ts-utils-luxon";
import { Duration } from "luxon";

const dateTimeNowRefreshDuration = Duration.fromDurationLike({ hours: 6 });

export interface BurnQualityContentProps {
  customerEnvironment: CustomerEnvironmentId;
  flue: Flue;
  showGoodInPercent: boolean;
  showBurnQualityCount: boolean;
  layout: SizeClass;
}

export const BurnQualityContent: FC<BurnQualityContentProps> = (props) => {
  const { flue, layout } = props;

  const now = useDateTimeNow(dateTimeNowRefreshDuration);
  const start = useMemo(() => flue.audit.created, [flue.audit.created]);
  const interval = useMemo(
    () => IntervalUtils.fromDateTimes(start, now),
    [start, now]
  );
  const showZoom = interval.end.diff(interval.start) > Duration.fromObject({ months: 4 });
  const burnDao = useBurnDao({
    customerEnvironment: props.customerEnvironment,
  });
  const expandedTimeUnit = "month";

  return (
    <BurnQualityCountAggregateByTimeLoader
      flueId={flue.id}
      start={start}
      end={now}
      aggregateBy={expandedTimeUnit}
      queryBurnQualityCountAggregate={burnDao.queryBurnQualityCountAggregate}
    >
      {({ data: aggregates, isFetching }) => {
        return (
          <BurnQualityCountAggregateByTimeChart
            hideAverageGoodInPercent={true}
            showBurnQualityCount={props.showBurnQualityCount}
            showGoodInPercent={props.showGoodInPercent}
            showRawGoodInPercent={false}
            interval={interval}
            timeUnit={expandedTimeUnit}
            aggregates={aggregates}
            xAxisZoomOptions={showZoom}
            loading={isFetching}
            layout={layout}
            sx={{ flexGrow: 1, minHeight: 0 }}
          />
        );
      }}
    </BurnQualityCountAggregateByTimeLoader>
  );
};
